<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Создание клиента</strong>
                </CCardHeader>
                <CCardBody>
                    <CForm>
                        <CInput
                            v-model="customer.phone"
                            label="Телефон"
                            placeholder="Формат: +7XXXXXXXXXX" />
                        <CInput v-model="customer.firstname" label="Имя" />
                        <CInput v-model="customer.lastname" label="Фамилия" />
                        <CInput
                            v-if="adminOnly"
                            v-model="customer.description"
                            label="Комментарий о клиенте" />
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">18+</CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="customer.adult"
                                />
                            </CCol>
                        </CRow>

                        <CRow
                            class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Пол
                            </CCol>
                            <CCol sm="9">
                                <CSelect
                                    horizontal
                                    :options="genderOptions"
                                    :value.sync="customer.gender"
                                    placeholder="Пол..."
                                />
                            </CCol>
                        </CRow>

                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Подтвержден</CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="customer.confirmed"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Активен</CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="customer.enabled"
                                />
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="create">Создать</CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="$router.push('/customers')">Отмена</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';

    export default {
        name: 'CustomerCreate',

        data() {
            return {
                customer: {
                    phone: '',
                    firstname: '',
                    lastname: '',
                    gender: 0,
                    description: '',
                    confirmed: false,
                    enabled: false
                },
                genderOptions: [
                    {
                        value: 0,
                        label: 'Не выбрано'
                    },
                    {
                        value: 1,
                        label: 'Мужской'
                    },
                    {
                        value: 2,
                        label: 'Женский'
                    },
                ]
            };
        },

        computed: {
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings'))
                    .is_business_admin;
            },
        },

        mounted() {},

        methods: {
            create() {
                if (!this.customer.phone) {
                    this.$root.$emit('showError', 'Укажите номер телефона.');
                    return;
                }
                Vue.axios
                    .post('/customers/create', this.customer)
                    .then(resp => {
                        this.$router.push({ path: '/customers/' + resp.data.id });
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка создания пользователя.');
                    });
            },

            goBack() {
                this.$router.push({ path: '/customers' });
            },
        },
    };
</script>
